import { defineMessages } from 'react-intl'

export default defineMessages({
  reqHead: {
    id: 'app.pages.PwdResetReq.reqHead',
    defaultMessage: 'Reset Password',
  },
  enterEmail: {
    id: 'app.pages.PwdResetReq.enterEmail',
    defaultMessage: "Enter your email and we'll send you a password reset link.",
  },

  reqReset: {
    id: 'app.pages.PwdResetReq.reqReset',
    defaultMessage: 'Request Reset',
  },
  requesting: {
    id: 'app.pages.PwdResetReq.requesting',
    defaultMessage: 'Requesting…',
  },

  linkSent: {
    id: 'app.pages.PwdResetReq.linkSent',
    defaultMessage: 'Password reset link sent',
  },
  checkInbox: {
    id: 'app.pages.PwdResetReq.checkInbox',
    defaultMessage: 'Check your inbox in a few moments.',
  },
  backToSignIn: {
    id: 'app.pages.PwdResetReq.backToSignIn',
    defaultMessage: 'Back to sign-in',
  },
})
